export default __webpack_public_path__ + "static/media/play (9) 1.21eef3bc.svg";